import logger from 'shared/services/logger'
import decodeEscapedString from 'shared/utils/decodeEscapedString'
import SearchBoxContainer from 'views/containers/browser/SearchBoxContainer'
import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'

export default ({ container, isMobile, i18n, query, ...props }) => {
  logger.info('Search module loaded')

  hydrateWithHOCs({
    container,
    i18n,
  })(
    <SearchBoxContainer
      inputId="h-SearchBox__input"
      mobile={isMobile}
      searchedQuery={decodeEscapedString(query)}
      {...props}
    />
  )
}
